  (function () {
    'use strict';

    /* One shared controller for every HK top bar on the page.
       Re-running this script (theme editor reloads, duplicate sections) only re-scans. */
    if (window.HKTopbar) { window.HKTopbar.initAll(); return; }

    var HOVER_MQ = '(hover: hover) and (pointer: fine) and (min-width: 990px)';
    // keep in step with hk_closed_words in sections/hk-topbar.liquid (server-rendered schedule rows)
    var CLOSED_WORDS = ['closed', 'închis', 'inchis', 'închisă', 'inchisa', 'закрыто', 'выходной', '-', '–', '—', 'x'];
    var NONSTOP_WORDS = ['non-stop', 'nonstop', '24/7', '24h', '24ore', 'круглосуточно'];
    var DEFAULT_T = {
      open: 'Deschis', closed: 'Închis', soon: 'Se închide curând',
      until: 'până la {time}', opensAt: 'deschide la {time}', opensDay: 'deschide {day}, {time}',
      tomorrow: 'mâine', special: 'Program special',
      daysShort: ['lun.', 'mar.', 'mie.', 'joi', 'vin.', 'sâm.', 'dum.']
    };

    var registry = []; // every open-able panel: { owner, isOpen(), close(restoreFocus) }

    function hoverCapable() {
      return !!(window.matchMedia && window.matchMedia(HOVER_MQ).matches);
    }
    function prune() {
      registry = registry.filter(function (e) { return e.owner.isConnected; });
    }
    function closeOthers(keepOwner, target) {
      prune();
      registry.forEach(function (e) {
        if (e.owner === keepOwner) return;
        if (target && e.owner.contains(target)) return;
        if (e.isOpen()) e.close(false);
      });
    }

    /* ---------------- time helpers ---------------- */
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function fmt(mins) {
      if (mins === 1440) return '24:00';
      mins = ((mins % 1440) + 1440) % 1440;
      return pad(Math.floor(mins / 60)) + ':' + pad(mins % 60);
    }
    function tpl(str, map) {
      return String(str || '').replace(/\{(\w+)\}/g, function (_, k) { return map[k] != null ? map[k] : ''; });
    }

    /* Wall-clock "now" in the shop's time zone (falls back to device time). */
    function zonedNow(tz) {
      var d = new Date();
      try {
        var parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).formatToParts(d);
        var o = {};
        parts.forEach(function (p) { o[p.type] = p.value; });
        return { y: +o.year, m: +o.month, d: +o.day, mins: (+o.hour % 24) * 60 + (+o.minute) };
      } catch (e) {
        return { y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate(), mins: d.getHours() * 60 + d.getMinutes() };
      }
    }
    /* Calendar day relative to "now" — pure date math in UTC, immune to DST shifts. */
    function dayAt(now, offset) {
      var t = new Date(Date.UTC(now.y, now.m - 1, now.d + offset));
      return {
        key: t.getUTCFullYear() + '-' + pad(t.getUTCMonth() + 1) + '-' + pad(t.getUTCDate()),
        dow: t.getUTCDay(),
        date: t
      };
    }

    /* ---------------- parsing ---------------- */
    function parseHours(raw) {
      var s = String(raw == null ? '' : raw).trim();
      var n = s.toLowerCase();
      if (!s || CLOSED_WORDS.indexOf(n) !== -1) return { kind: 'closed', ranges: [], raw: s };
      if (NONSTOP_WORDS.indexOf(n.replace(/\s+/g, '')) !== -1) {
        return { kind: 'ranges', nonstop: true, ranges: [{ open: 0, close: 1440 }], raw: s };
      }
      var ranges = [];
      var ok = true;
      s.split(/[,;]+/).forEach(function (part) {
        part = part.replace(/\s+/g, '');
        if (!part) return;
        var m = part.match(/^(\d{1,2})[:.](\d{2})[-–—](\d{1,2})[:.](\d{2})$/);
        if (!m || +m[2] > 59 || +m[4] > 59) { ok = false; return; }
        var o = (+m[1]) * 60 + (+m[2]);
        var c = (+m[3]) * 60 + (+m[4]);
        if (o >= 1440 || c > 1440) { ok = false; return; }
        if (c <= o) c += 1440; // overnight, e.g. 22:00 - 02:00
        ranges.push({ open: o, close: c });
      });
      if (!ok || !ranges.length) return { kind: 'text', ranges: [], raw: s };
      ranges.sort(function (a, b) { return a.open - b.open; });
      return { kind: 'ranges', ranges: ranges, raw: s };
    }

    function parseSpecial(text) {
      var map = {};
      String(text || '').split(/\r?\n/).forEach(function (line) {
        line = line.trim();
        if (!line || line.charAt(0) === '#') return;
        var key, rest;
        var iso = line.match(/^(\d{4})-(\d{1,2})-(\d{1,2})\s*(?:=|:)?\s*(.*)$/);
        var eu = line.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})\s*(?:=|:)?\s*(.*)$/);
        if (iso) { key = iso[1] + '-' + pad(+iso[2]) + '-' + pad(+iso[3]); rest = iso[4]; }
        else if (eu) { key = eu[3] + '-' + pad(+eu[2]) + '-' + pad(+eu[1]); rest = eu[4]; }
        else return;
        var note = '';
        var bar = rest.indexOf('|');
        if (bar !== -1) { note = rest.slice(bar + 1).trim(); rest = rest.slice(0, bar); }
        map[key] = { hours: parseHours(rest), note: note };
      });
      return map;
    }

    function readConfig(el) {
      var raw;
      try { raw = JSON.parse(el.textContent); } catch (e) { return null; }
      var weekly = [];
      for (var i = 0; i < 7; i++) weekly.push(parseHours((raw.hours || [])[i]));
      var t = {};
      Object.keys(DEFAULT_T).forEach(function (k) {
        var v = raw.t && raw.t[k];
        t[k] = (v != null && v !== '') ? v : DEFAULT_T[k];
      });
      if (!Array.isArray(t.daysShort) || t.daysShort.length !== 7) t.daysShort = DEFAULT_T.daysShort;
      return {
        tz: raw.tz || 'Europe/Chisinau',
        locale: raw.locale || 'ro',
        weekly: weekly,
        special: parseSpecial(raw.special),
        soon: Math.max(0, parseInt(raw.soon, 10) || 0),
        t: t
      };
    }

    function hoursFor(cfg, day) {
      var sp = cfg.special[day.key];
      return sp ? sp.hours : cfg.weekly[day.dow];
    }

    /* ---------------- status ---------------- */
    function computeStatus(cfg, now) {
      var mins = now.mins;
      var i, r;

      var today = hoursFor(cfg, dayAt(now, 0));
      if (today.nonstop) return { state: 'open', nonstop: true, raw: today.raw };

      // spill-over from yesterday's overnight range
      var y = hoursFor(cfg, dayAt(now, -1)).ranges;
      for (i = 0; i < y.length; i++) {
        if (y[i].close > 1440 && mins < y[i].close - 1440) {
          return { state: 'open', closeAt: y[i].close - 1440, left: y[i].close - 1440 - mins };
        }
      }

      r = today.ranges;
      for (i = 0; i < r.length; i++) {
        if (mins >= r[i].open && mins < r[i].close) {
          return { state: 'open', closeAt: r[i].close, left: r[i].close - mins };
        }
      }
      for (i = 0; i < r.length; i++) {
        if (r[i].open > mins) return { state: 'closed', next: { offset: 0, at: r[i].open } };
      }
      for (var d = 1; d <= 14; d++) {
        var day = dayAt(now, d);
        var rr = hoursFor(cfg, day).ranges;
        if (rr.length) return { state: 'closed', next: { offset: d, dow: day.dow, at: rr[0].open } };
      }
      return { state: 'closed', next: null };
    }

    function statusLabel(cfg, st) {
      var t = cfg.t;
      if (st.state === 'open') {
        return st.nonstop ? t.open + ' · ' + st.raw : t.open + ' · ' + tpl(t.until, { time: fmt(st.closeAt) });
      }
      if (st.state === 'soon') return t.soon + ' · ' + fmt(st.closeAt);
      if (!st.next) return t.closed;
      if (st.next.offset === 0) return t.closed + ' · ' + tpl(t.opensAt, { time: fmt(st.next.at) });
      var dayName = st.next.offset === 1 ? t.tomorrow : t.daysShort[(st.next.dow + 6) % 7];
      return t.closed + ' · ' + tpl(t.opensDay, { day: dayName, time: fmt(st.next.at) });
    }

    function hoursText(h, t) {
      if (h.kind === 'closed') return t.closed;
      if (h.kind === 'ranges' && !h.nonstop) {
        return h.ranges.map(function (r) { return fmt(r.open) + ' – ' + fmt(r.close); }).join(', ');
      }
      return h.raw;
    }

    function fmtDate(date, locale) {
      try {
        return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(date);
      } catch (e) {
        return pad(date.getUTCDate()) + '.' + pad(date.getUTCMonth() + 1);
      }
    }

    /* The weekly list doubles as "the next 7 days": today is highlighted and
       any special day in the coming week replaces its weekday's normal hours. */
    function renderRows(ctx, now) {
      var cfg = ctx.cfg;
      var t = cfg.t;
      var notes = [];
      for (var off = 0; off < 7; off++) {
        var day = dayAt(now, off);
        var row = ctx.drop.querySelector('[data-day="' + day.dow + '"]');
        if (!row) continue;
        var sp = cfg.special[day.key];
        var h = sp ? sp.hours : cfg.weekly[day.dow];
        row.classList.toggle('is-today', off === 0);
        row.classList.toggle('is-special', !!sp);
        var cell = row.querySelector('.hk-topbar__scheduleHours');
        if (cell) {
          cell.textContent = '';
          if (h.kind === 'closed') {
            var s = document.createElement('span');
            s.className = 'hk-topbar__scheduleClosed';
            s.textContent = t.closed;
            cell.appendChild(s);
          } else {
            cell.textContent = hoursText(h, t);
          }
        }
        if (sp) notes.push({ date: day.date, hours: h, note: sp.note });
      }

      var noteEl = ctx.drop.querySelector('.hk-topbar__dropNote');
      if (!noteEl) return;
      noteEl.textContent = '';
      if (!notes.length) { noteEl.hidden = true; return; }
      var title = document.createElement('div');
      title.className = 'hk-topbar__dropNoteTitle';
      title.textContent = t.special;
      noteEl.appendChild(title);
      notes.forEach(function (n) {
        var line = document.createElement('div');
        line.textContent = fmtDate(n.date, cfg.locale) + ' · ' + hoursText(n.hours, t) + (n.note ? ' · ' + n.note : '');
        noteEl.appendChild(line);
      });
      noteEl.hidden = false;
    }

    function update(ctx) {
      var cfg = ctx.cfg;
      var now = zonedNow(cfg.tz);
      var st = computeStatus(cfg, now);
      if (st.state === 'open' && !st.nonstop && cfg.soon > 0 && st.left <= cfg.soon) st.state = 'soon';

      var text = statusLabel(cfg, st);
      if (ctx.badge) ctx.badge.setAttribute('data-status', st.state);
      if (ctx.labelEl && ctx.labelEl.textContent !== text) ctx.labelEl.textContent = text;
      if (ctx.dropStatus) {
        ctx.dropStatus.setAttribute('data-status', st.state);
        var dt = ctx.dropStatus.querySelector('.hk-topbar__dropStatusText');
        if (dt) dt.textContent = st.state === 'open' ? cfg.t.open : (st.state === 'soon' ? cfg.t.soon : cfg.t.closed);
      }
      renderRows(ctx, now);
    }

    /* ---------------- schedule dropdown (disclosure pattern) ---------------- */
    function setupSchedule(block) {
      if (block.__hkSchedule) return block.__hkSchedule;
      var btn = block.querySelector('.hk-topbar__scheduleBtn');
      var drop = block.querySelector('.hk-topbar__scheduleDropdown');
      var cfgEl = block.querySelector('script[data-hk-schedule-config]');
      if (!btn || !drop || !cfgEl) return null;
      var cfg = readConfig(cfgEl);
      if (!cfg) return null;

      var ctx = {
        cfg: cfg,
        btn: btn,
        drop: drop,
        badge: btn.querySelector('.hk-topbar__statusBadge'),
        labelEl: btn.querySelector('.hk-topbar__statusLabel'),
        dropStatus: drop.querySelector('.hk-topbar__dropStatus')
      };

      var isOpen = false;
      var via = null; // 'hover' | 'click' | 'editor'
      var timer = null;

      function open(how) {
        clearTimeout(timer);
        closeOthers(block, null);
        isOpen = true;
        via = how;
        drop.setAttribute('data-open', 'true');
        btn.setAttribute('aria-expanded', 'true');
      }
      function close(restoreFocus) {
        clearTimeout(timer);
        if (!isOpen) return;
        isOpen = false;
        via = null;
        drop.setAttribute('data-open', 'false');
        btn.setAttribute('aria-expanded', 'false');
        if (restoreFocus) btn.focus();
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!isOpen) { open('click'); return; }
        // Opened by hover: a click pins it open instead of slamming it shut under the cursor.
        if (via === 'hover') { via = 'click'; return; }
        close(false);
      });

      block.addEventListener('mouseenter', function () {
        if (!hoverCapable()) return;
        if (isOpen) { clearTimeout(timer); return; }
        open('hover');
      });
      block.addEventListener('mouseleave', function () {
        if (!hoverCapable() || via !== 'hover') return;
        clearTimeout(timer);
        timer = setTimeout(function () { close(false); }, 140);
      });
      block.addEventListener('focusout', function (e) {
        var to = e.relatedTarget;
        if (isOpen && to && !block.contains(to)) close(false);
      });

      registry.push({ owner: block, isOpen: function () { return isOpen; }, close: close });

      ctx.update = function () { update(ctx); };
      ctx.open = open;
      ctx.close = close;
      block.__hkSchedule = ctx;
      update(ctx);
      return ctx;
    }

    /* ---------------- language switcher hover (desktop) ---------------- */
    function setupLang(root) {
      root.querySelectorAll('.hk-topbar__lang .disclosure').forEach(function (dis) {
        if (dis.__hkLang) return;
        dis.__hkLang = true;

        var btn = dis.querySelector('.disclosure__button');
        var panel = dis.querySelector('.disclosure__list-wrapper');
        if (!btn || !panel) return;

        var via = null;
        var timer = null;
        function isOpen() { return !panel.hidden; }
        function open() {
          clearTimeout(timer);
          closeOthers(dis, null);
          panel.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          via = 'hover';
        }
        function close(restoreFocus) {
          clearTimeout(timer);
          via = null;
          if (panel.hidden) return;
          panel.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
          if (restoreFocus) btn.focus();
        }

        dis.addEventListener('mouseenter', function () {
          if (!hoverCapable()) return;
          if (isOpen()) { clearTimeout(timer); return; }
          open();
        });
        dis.addEventListener('mouseleave', function () {
          if (!hoverCapable() || via !== 'hover') return;
          clearTimeout(timer);
          timer = setTimeout(function () { close(false); }, 140);
        });

        // Capture phase: when hover already opened the panel, stop Dawn's click
        // handler from toggling it shut under the cursor — the click pins it instead.
        dis.addEventListener('click', function (e) {
          if (via === 'hover' && isOpen() && btn.contains(e.target)) {
            e.preventDefault();
            e.stopPropagation();
            via = 'click';
          }
        }, true);

        registry.push({ owner: dis, isOpen: isOpen, close: close });
      });
    }

    /* ---------------- lifecycle ---------------- */
    function initRoot(root) {
      if (!root || root.__hkInit) return;
      root.__hkInit = true;
      var ctxs = [];
      root.querySelectorAll('[data-hk-schedule]').forEach(function (block) {
        var c = setupSchedule(block);
        if (c) ctxs.push(c);
      });
      setupLang(root);
      root.__hkCtxs = ctxs;
      if (ctxs.length) {
        root.__hkTimer = window.setInterval(function () {
          if (document.hidden) return; // a hidden tab catches up on visibilitychange (refreshAll)
          ctxs.forEach(function (c) { c.update(); });
        }, 30000);
      }
    }
    function destroyRoot(root) {
      if (root.__hkTimer) window.clearInterval(root.__hkTimer);
      root.__hkTimer = null;
      root.__hkInit = false;
      prune();
    }
    function initAll() {
      document.querySelectorAll('[data-hk-topbar]').forEach(initRoot);
    }
    function refreshAll() {
      document.querySelectorAll('[data-hk-topbar]').forEach(function (root) {
        (root.__hkCtxs || []).forEach(function (c) { c.update(); });
      });
    }

    document.addEventListener('click', function (e) { closeOthers(null, e.target); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      prune();
      registry.forEach(function (en) {
        if (en.isOpen()) en.close(en.owner.contains(document.activeElement));
      });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshAll();
    });

    // Theme editor
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.querySelectorAll) e.target.querySelectorAll('[data-hk-topbar]').forEach(destroyRoot);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var c = e.target && e.target.__hkSchedule;
      if (c) c.open('editor');
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var c = e.target && e.target.__hkSchedule;
      if (c) c.close(false);
    });

    /* The one opening-hours answer for the whole site (ARCH-032): the contact and rental pages ask
       this instead of keeping their own copies, so special days and overnight hours agree everywhere.
       Returns null when the page has no top-bar schedule. */
    function status() {
      var el = document.querySelector('[data-hk-schedule-config]');
      var cfg = el && readConfig(el);
      if (!cfg) return null;
      var now = zonedNow(cfg.tz);
      var st = computeStatus(cfg, now);
      var today = hoursFor(cfg, dayAt(now, 0));
      // label / today: the top bar's own wording, for other places that show the hours (mobile drawer, UX-004)
      var shown = st;
      if (st.state === 'open' && !st.nonstop && cfg.soon > 0 && st.left <= cfg.soon) {
        shown = { state: 'soon', closeAt: st.closeAt, left: st.left };
      }
      return {
        open: st.state === 'open',
        state: st.state,
        special: !!cfg.special[dayAt(now, 0).key],
        label: statusLabel(cfg, shown),
        today: hoursText(today, cfg.t)
      };
    }

    window.HKTopbar = { initAll: initAll, refresh: refreshAll, status: status };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
